<template>
<section class="rent-report header-margin">
    <a class="rent-report__breadcrumb" href="/analytics/interesting-on-the-market/">
        Интересное по рынку
    </a>
    <h1 class="rent-report__title">{{ report.report_info.title }}</h1>
    <div class="rent-report__date-container">
        <p class="rent-report__date">Дата публикации: {{ report.report_info.date }}</p>
        <div class="rent-report-wrapper">
            <button-share></button-share>
            <a class="rent-report__btn rent-report__btn--primary rent-report__btn--icon-left"
                :href="report.report_info.report_file.src" :title="report.report_info.report_file.original_name"
                :download="report.report_info.report_file.original_name">
                <svg class="rent-report__btn-svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M12 1.5C12.5523 1.5 13 1.94772 13 2.5L13 12.1771L15.8271 9.3508C16.2177 8.96033 16.8508 8.96041 17.2413 9.35099C17.6318 9.74157 17.6317 10.3747 17.2411 10.7652L12.707 15.2981C12.3165 15.6885 11.6835 15.6885 11.293 15.2981L6.75889 10.7652C6.36832 10.3747 6.36824 9.74157 6.75871 9.35099C7.14918 8.96041 7.78235 8.96033 8.17292 9.3508L11 12.1771L11 2.5C11 1.94772 11.4477 1.5 12 1.5ZM3 15C3.55228 15 4 15.4477 4 16V21L20 21L20 16C20 15.4477 20.4477 15 21 15C21.5523 15 22 15.4477 22 16L22 21.25C22 21.7436 21.7853 22.1974 21.4361 22.5175C21.0898 22.8349 20.6373 23 20.1818 23L3.81818 23C3.36269 23 2.91023 22.8349 2.56392 22.5175C2.21469 22.1974 2 21.7436 2 21.25L2 16C2 15.4477 2.44772 15 3 15Z"
                        fill="white" />
                </svg>
                <span class="rent-report__btn-txt">
                    Скачать весь отчет
                </span>
            </a>
        </div>
    </div>
</section>
<section class="rent-report rent-report__heading">
    <ul class="rent-report__heading-list" v-html="report.report_info.detail_text"></ul>
    <div class="rent-report__heading-img">
        <img class="" :src="setPicture" alt="" />
    </div>

</section>

<section class="rent-report n-mb-8">
    <div class="rent-report__charts">
        <div class="rent-report__chart-block">
            <h2 class="rent-report__chart-title">Динамика предложений аренды квартир в России</h2>
            <div class="js--rent-report">
                <rent-report :report='report.rental_offers_dynamics'>
                </rent-report>
                <!-- <div id="js--rent-report">
                </div> -->
            </div>
        </div>

        <div class="rent-report__chart-block">
            <h2 class="rent-report__chart-title">Динамика новых и закрытых объявлений о сдаче квартир в России</h2>
            <div class="js--rent-report-closed">
                <rent-report-closed :report='report.advertisements_for_rent'>
                </rent-report-closed>
                <!-- <div id="js--rent-report-closed">
                </div> -->
            </div>
        </div>
        <div id="chartjs-tooltip"></div>
        <div id="chartjs-tooltip1"></div>
    </div>
    <div class="rent-report__chart-subtitle">
        Данные по предложению аренды квартир в обзоре приведены на основе базы ЦИАН. На количество объявлений, помимо
        рыночных условий, влияют изменения в политике монетизации и модерации сервиса размещения объявлений
    </div>
</section>

<market-indicator :city="report.report_by_city"
    :link="{ src: report.report_info.report_file.src, title: report.report_info.report_file.original_name, download: report.report_info.report_file.original_name }"></market-indicator>


<report-period :reportId="report.report_info.id"></report-period>
</template>


<script>
import ReportPeriod from './ReportPeriod.vue'
import RentReport from './RentReport.vue'
import RentReportClosed from './RentReportClosed.vue'
import MarketIndicator from './MarketIndicator.vue'
import ButtonShare from '@/js/vue-components/ui/ButtonShare'

export default {
    name: 'RentalHousingReportDetail',
    components: {
        ButtonShare, ReportPeriod, MarketIndicator, RentReport, RentReportClosed
    },
    props: {
        report: {
            type: Object
        },
    },
    data() {
        return {
            defaultPicture: '/static/v2/src/img/analytics/rent-report/image-heading.jpg'
        }
    },
    computed: {
        setPicture() {
            return this.report.report_info.detail_picture ? this.report.report_info.detail_picture : this.defaultPicture;
        }
    },
}
</script>